import api from "services/api";
import { routers_constants } from "services/constants";

interface IParam {
  audienceId: number;
}

interface IInProgress {
  id: number;
  hearingId: number;
  type: number;
  title: string;
  filename: string;
  recordId: string;
  duration: number;
  size: number;
  fileOrder: number;
  hash: string;
  startDate: string;
  finishDate: null;
  createIn: string;
  updateIn: string;
  download: true;
  upload: true;
  watermark: number;
  platform: number;
  status: number;
  device: null;
  ip: null;
  logPoliceUnitId: number;
  logUserId: number;
}

interface IHearingAttendant {
  id: number;
  name: string;
  role: string;
  attendantId: number;
  attendantRoleId: number;
  extraData: null | string;
}

interface IReponseAudienceRecord {
  hearingScheduled: Array<any>;
  hearingInProgress: Array<IInProgress>;
  hearingAttendants: Array<IHearingAttendant>;
}

export interface IReturn {
  data: IReponseAudienceRecord;
  success: boolean;
}

export const recordersServices = {
  getListByAudienceId: async ({ audienceId }: IParam): Promise<IReturn> => {
    try {
      const { data } = await api.get(
        routers_constants.recordedAudiences.getListByAudienceId(audienceId),
      );

      return {
        data: data.data,
        success: true,
      };
    } catch (error: any) {
      return {
        data: error?.response?.data,
        success: false,
      };
    }
  },
};
